import React, { useState } from "react";
import Content from "./content";
import Control from "./control";
import { ID } from "utils/constants";
import "./index.scss";
import Icon from "components/utils/icon";

const DEFAULT = ID.CHAT;

const Application = ({ openModal }) => {
  const [current, setCurrent] = useState(DEFAULT);
  const [showMessage, setShowMessage] = useState(false);

  const toggleApplication = (application) => {
    if (current !== application) setCurrent(application);
  };

  return (
    <div
      style={{
        position: "absolute",
        zIndex: 2,
        left: 0,
        bottom: 30,
        display: "flex",
        flexDirection: "row",
      }}
    >
      {!showMessage && (
        <div style={{ marginLeft: 12, marginBottom: 12 }}>
          <Icon
            onClick={() => setShowMessage(true)}
            name="chat"
            size={32}
            color="white"
          />
        </div>
      )}
      {!showMessage && (
        <div style={{ marginLeft: 12, marginBottom: 12 }}>
          <Icon
            onClick={() => openModal(ID.INFORMATION_MODAL)}
            name="info-circle"
            size={32}
            color="white"
          />
        </div>
      )}
      <div className={`application ${showMessage ? "active" : ""}`}>
        <Control
          current={current}
          toggleHideMessage={() => setShowMessage(false)}
          toggleApplication={toggleApplication}
        />
        <Content current={current} />
      </div>
    </div>
  );
};

const areEqual = () => true;

export default React.memo(Application, areEqual);
